import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function Analisis() {
  const [seccion, setSeccion] = useState('general');
  const [general, setGeneral] = useState(null);
  const [compras, setCompras] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [productos, setProductos] = useState([]);
  const [busquedaProd, setBusquedaProd] = useState('');
  const [busquedaProv, setBusquedaProv] = useState('');
  const [cargando, setCargando] = useState(false);
  const [filtroDesde, setFiltroDesde] = useState('');
  const [filtroHasta, setFiltroHasta] = useState('');
  const [proveedorDetalle, setProveedorDetalle] = useState(null);
  const [detalleProveedor, setDetalleProveedor] = useState([]);
  const [filtroDesdeDetalle, setFiltroDesdeDetalle] = useState('');
  const [filtroHastaDetalle, setFiltroHastaDetalle] = useState('');

  // Búsqueda avanzada
  const [listaProveedores, setListaProveedores] = useState([]);
  const [listaProductos, setListaProductos] = useState([]);
  const [filtroProvBusq, setFiltroProvBusq] = useState('');
  const [filtroProdBusq, setFiltroProdBusq] = useState('');
  const [filtroDesdeGen, setFiltroDesdeGen] = useState('');
  const [filtroHastaGen, setFiltroHastaGen] = useState('');
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [resultadoBusqueda, setResultadoBusqueda] = useState([]);
  const [productoDetalle, setProductoDetalle] = useState(null);
  const [buscando, setBuscando] = useState(false);

  // Ranking errores
  const [rankingErrores, setRankingErrores] = useState([]);
  const [tipoRanking, setTipoRanking] = useState('proveedor');
  const [filtroDesdeRanking, setFiltroDesdeRanking] = useState('');
  const [filtroHastaRanking, setFiltroHastaRanking] = useState('');
  const [cargandoRanking, setCargandoRanking] = useState(false);
  const [vistaPeso, setVistaPeso] = useState("proveedores");
  const [pesoRankingGeneral, setPesoRankingGeneral] = useState([]);
  const [pesoProveedores, setPesoProveedores] = useState([]);
  const [pesoProductos, setPesoProductos] = useState([]);
  const [pesoDetalle, setPesoDetalle] = useState([]);
  const [pesoDetalleTitulo, setPesoDetalleTitulo] = useState("");
  const [pesoDetalleTipo, setPesoDetalleTipo] = useState(null);
  const [pesoPlanId, setPesoPlanId] = useState("");
  const [cargandoPeso, setCargandoPeso] = useState(false);
  const [planesParaPeso, setPlanesParaPeso] = useState([]);

  const token = localStorage.getItem('token');

  const cargarGeneral = async () => {
    setCargando(true);
    try {
      const [resGen, resProvs, resPrds] = await Promise.all([
        axios.get('https://comprasmercadomodelo.online/api/analisis/general', { headers: { authorization: token } }),
        axios.get('https://comprasmercadomodelo.online/api/analisis/lista-proveedores', { headers: { authorization: token } }),
        axios.get('https://comprasmercadomodelo.online/api/analisis/lista-productos', { headers: { authorization: token } })
      ]);
      setGeneral(resGen.data);
      setListaProveedores(resProvs.data);
      setListaProductos(resPrds.data);
    } catch (err) { console.error(err); }
    setCargando(false);
  };

  const cargarCompras = async () => {
    setCargando(true);
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/analisis/compras', { headers: { authorization: token } });
      setCompras(res.data);
    } catch (err) { console.error(err); }
    setCargando(false);
  };

  const cargarProveedores = async () => {
    setCargando(true);
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/analisis/proveedores', { headers: { authorization: token } });
      setProveedores(res.data);
    } catch (err) { console.error(err); }
    setCargando(false);
  };

  const cargarProductos = async () => {
    setCargando(true);
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/analisis/productos', { headers: { authorization: token } });
      setProductos(res.data);
    } catch (err) { console.error(err); }
    setCargando(false);
  };

  const cargarRankingErrores = async () => {
    setCargandoRanking(true);
    try {
      const params = [`tipo=${tipoRanking}`];
      if (filtroDesdeRanking) params.push(`desde=${filtroDesdeRanking}`);
      if (filtroHastaRanking) params.push(`hasta=${filtroHastaRanking}`);
      const res = await axios.get(`https://comprasmercadomodelo.online/api/analisis/ranking-errores?${params.join('&')}`, {
        headers: { authorization: token }
      });
      setRankingErrores(res.data);
    } catch (err) { console.error(err); }
    setCargandoRanking(false);
  };

  const cargarPesoRankingGeneral = async () => {
    setCargandoPeso(true);
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/ranking-general", { headers: { authorization: token } });
      setPesoRankingGeneral(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };

  const cargarPesoProveedores = async () => {
    setCargandoPeso(true);
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/proveedores", { headers: { authorization: token } });
      setPesoProveedores(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };

  const cargarPesoProductos = async () => {
    setCargandoPeso(true);
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/productos", { headers: { authorization: token } });
      setPesoProductos(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };

  const cargarPesoDetalleProveedor = async (prov) => {
    setCargandoPeso(true);
    setPesoDetalleTipo("proveedor");
    setPesoDetalleTitulo(prov.nombre);
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/proveedores/" + prov.id, { headers: { authorization: token } });
      setPesoDetalle(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };

  const cargarPesoDetalleProducto = async (prod) => {
    setCargandoPeso(true);
    setPesoDetalleTipo("producto");
    setPesoDetalleTitulo(prod.nombre);
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/productos/" + prod.id, { headers: { authorization: token } });
      setPesoDetalle(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };

  const cargarPesoPlan = async (planId) => {
    if (!planId) { setPesoDetalle([]); return; }
    setCargandoPeso(true);
    setPesoDetalleTipo("plan");
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/analisis/diferencias-peso/plan/" + planId, { headers: { authorization: token } });
      setPesoDetalle(res.data);
    } catch (err) { console.error(err); }
    setCargandoPeso(false);
  };
  const cargarPlanesParaPeso = async () => {
    try {
      const res = await axios.get("https://comprasmercadomodelo.online/api/planes", { headers: { authorization: token } });
      setPlanesParaPeso(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarDetalleProveedor = async (prov, desde = '', hasta = '') => {
    setCargando(true);
    try {
      let url = `https://comprasmercadomodelo.online/api/analisis/proveedores/${prov.id}/detalle`;
      const params = [];
      if (desde) params.push(`desde=${desde}`);
      if (hasta) params.push(`hasta=${hasta}`);
      if (params.length) url += '?' + params.join('&');
      const res = await axios.get(url, { headers: { authorization: token } });
      setDetalleProveedor(res.data);
      setProveedorDetalle(prov);
    } catch (err) { console.error(err); }
    setCargando(false);
  };

  const buscarAvanzado = async () => {
    setBuscando(true);
    try {
      const params = [];
      if (filtroDesdeGen) params.push(`desde=${filtroDesdeGen}`);
      if (filtroHastaGen) params.push(`hasta=${filtroHastaGen}`);
      if (filtroProvBusq) params.push(`proveedor_id=${filtroProvBusq}`);
      if (productosSeleccionados.length > 0) params.push(`producto_ids=${productosSeleccionados.join(',')}`);
      const url = `https://comprasmercadomodelo.online/api/analisis/busqueda${params.length ? '?' + params.join('&') : ''}`;
      const res = await axios.get(url, { headers: { authorization: token } });
      setResultadoBusqueda(res.data);
      setProductoDetalle(null);
    } catch (err) { console.error(err); }
    setBuscando(false);
  };

  useEffect(() => {
    if (seccion === 'general') cargarGeneral();
    if (seccion === 'compras') cargarCompras();
    if (seccion === 'proveedores') cargarProveedores();
    if (seccion === 'productos') cargarProductos();
    if (seccion === 'peso' && vistaPeso === 'proveedores') cargarPesoProveedores();
    if (seccion === 'peso' && vistaPeso === 'productos') cargarPesoProductos();
    if (seccion === 'peso' && vistaPeso === 'plan') cargarPlanesParaPeso();
    if (seccion === 'peso' && vistaPeso === 'ranking') cargarPesoRankingGeneral();
    if (seccion === 'ranking') cargarRankingErrores();
  }, [seccion]);

  useEffect(() => {
    if (seccion === "peso" && vistaPeso === "proveedores") cargarPesoProveedores();
    if (seccion === "peso" && vistaPeso === "productos") cargarPesoProductos();
    if (seccion === "peso" && vistaPeso === "plan") cargarPlanesParaPeso();
    if (seccion === "peso" && vistaPeso !== "proveedores" && vistaPeso !== "productos" && vistaPeso !== "plan") setPesoDetalle([]);
    if (seccion === "peso" && vistaPeso === "ranking") cargarPesoRankingGeneral();
  }, [vistaPeso]);
  useEffect(() => {
    if (seccion === "ranking") cargarRankingErrores();
  }, [tipoRanking]);

  const toggleProducto = (id) => {
    setProductosSeleccionados(prev =>
      prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
    );
  };

  const filtrarPorFecha = (lista, campoFecha = 'fecha') => {
    return lista.filter(item => {
      const fecha = new Date(item[campoFecha]);
      if (filtroDesde && fecha < new Date(filtroDesde)) return false;
      if (filtroHasta && fecha > new Date(filtroHasta + 'T23:59:59')) return false;
      return true;
    });
  };

  const comprasFiltradas = filtrarPorFecha(compras);
  const proveedoresFiltrados = proveedores.filter(p =>
    p.nombre.toLowerCase().includes(busquedaProv.toLowerCase())
  );
  const productosFiltrados = productos.filter(p =>
    p.nombre.toLowerCase().includes(busquedaProd.toLowerCase()) ||
    String(p.codigo_barras).includes(busquedaProd)
  );

  const detalleAgrupado = detalleProveedor.reduce((acc, d) => {
    const key = d.producto_nombre;
    if (!acc[key]) acc[key] = [];
    acc[key].push(d);
    return acc;
  }, {});

  const resultadoAgrupado = resultadoBusqueda.reduce((acc, d) => {
    const key = `${d.producto_codigo}-${d.producto_nombre}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(d);
    return acc;
  }, {});

  const getPorcentaje = (exactos, total) => {
    if (!total) return 0;
    return Math.round((exactos / total) * 100);
  };

  const getColorPorcentaje = (pct) => {
    if (pct >= 90) return '#27ae60';
    if (pct >= 70) return '#f39c12';
    return '#e74c3c';
  };

  const getEstadoLabel = (estado) => {
    const map = {
      verde: '🟢 Verde', punto_medio: '🟡 Punto medio',
      maduro: '🟠 Maduro', demasiado_maduro: '🔴 Demasiado maduro'
    };
    return map[estado] || '-';
  };

  const exportarExcelRanking = () => {
    const wb = XLSX.utils.book_new();
    const data = rankingErrores.map((r, i) => tipoRanking === 'proveedor' ? ({
      'Posición': i + 1,
      'Proveedor': r.nombre,
      'Código': r.codigo_sistema,
      'Total Compras': r.total_compras,
      'Total Pedidos': r.total_pedidos,
      'Errores Cantidad': r.errores_cantidad || 0,
      'Unidades Diferencia': r.total_unidades_dif || 0,
      'Veces Demasiado Maduro': r.veces_demasiado_maduro || 0,
      'Veces Maduro': r.veces_maduro || 0,
      'Cambios Estado': r.cambios_estado || 0,
      'Con Observaciones': r.veces_con_obs || 0,
      'Veces Avisado': r.veces_avisado || 0,
      '% Exactitud': `${r.pct_exactitud || 0}%`
    }) : ({
      'Posición': i + 1,
      'Producto': r.nombre,
      'Código': r.codigo_barras,
      'Total Compras': r.total_compras,
      'Errores Cantidad': r.errores_cantidad || 0,
      'Unidades Diferencia': r.total_unidades_dif || 0,
      'Veces Demasiado Maduro': r.veces_demasiado_maduro || 0,
      'Veces Maduro': r.veces_maduro || 0,
      'Cambios Estado': r.cambios_estado || 0,
      'Con Observaciones': r.veces_con_obs || 0,
      'Proveedores': r.proveedores || ''
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Ranking Errores');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Ranking_Errores_${tipoRanking}_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
  };

  const exportarExcelBusqueda = () => {
    const wb = XLSX.utils.book_new();
    const data = resultadoBusqueda.map(d => ({
      'Fecha': new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" }),
      'Código': d.producto_codigo, 'Producto': d.producto_nombre,
      'Proveedor': d.proveedor_nombre, 'Comprado': d.cantidad_pedida,
      'Descargado': d.cantidad_descargada_real || 0, 'Precio $': d.precio,
      'Precio Mín $': d.precio_minimo, 'Precio Máx $': d.precio_maximo,
      'Dif. Carga': d.dif_carga || 0, 'Dif. Descarga': d.dif_descarga || 0,
      'Estado Compra': getEstadoLabel(d.estado_mercaderia),
      'Estado Descarga': getEstadoLabel(d.estado_mercaderia_descarga),
      'Kg Estimado': d.kg_estimado || 0, 'Kg Real': d.kg_real || 0,
      'Observación': d.observacion_descarga || ''
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Búsqueda');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Busqueda_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
  };

  const exportarExcelProveedores = () => {
    const wb = XLSX.utils.book_new();
    const data = proveedoresFiltrados.map(p => ({
      'Código': p.codigo_sistema, 'Proveedor': p.nombre,
      'Compras': p.total_compras, 'Total Comprado': p.total_comprado || 0,
      'Total Descargado': p.total_descargado || 0,
      'Importe Total $': Number(p.total_importe || 0).toFixed(2),
      'Dif. Carga': p.total_dif_carga || 0, 'Dif. Descarga': p.total_dif_descarga || 0,
      '% Exactitud': `${getPorcentaje(p.pedidos_exactos, p.total_pedidos)}%`,
      'Observaciones': p.total_observaciones || 0
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Resumen');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Proveedores_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
  };

  const exportarExcelDetalleProveedor = () => {
    if (!proveedorDetalle) return;
    const wb = XLSX.utils.book_new();
    const data = detalleProveedor.map(d => ({
      'Fecha': new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" }),
      'Producto': d.producto_nombre, 'Código': d.producto_codigo,
      'Comprado': d.cantidad_pedida, 'Cargado': d.cantidad_cargada || 0,
      'Descargado': d.cantidad_descargada_real || 0,
      'Dif. Carga': d.dif_carga || 0, 'Dif. Descarga': d.dif_descarga || 0,
      'Precio $': d.precio,
      'Estado Compra': getEstadoLabel(d.estado_mercaderia),
      'Estado Descarga': getEstadoLabel(d.estado_mercaderia_descarga),
      'Kg Estimado': d.kg_estimado || 0, 'Kg Real': d.kg_real || 0,
      'Observación': d.observacion_descarga || ''
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Detalle');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${proveedorDetalle.nombre}_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
  };

  const exportarExcelProductos = () => {
    const wb = XLSX.utils.book_new();
    const data = productosFiltrados.map(p => ({
      'Código': p.codigo_barras, 'Producto': p.nombre, 'Proveedores': p.proveedores || '',
      'Veces Comprado': p.veces_comprado,
      'Precio Mín $': Number(p.precio_minimo || 0).toFixed(2),
      'Precio Prom $': Number(p.precio_promedio || 0).toFixed(2),
      'Precio Máx $': Number(p.precio_maximo || 0).toFixed(2),
      'Diferencias': p.total_diferencias || 0
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Productos');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Productos_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
  };

  const listaProductosFiltrada = listaProductos.filter(p =>
    p.nombre.toLowerCase().includes(filtroProdBusq.toLowerCase()) ||
    String(p.codigo_barras).includes(filtroProdBusq)
  );

  if (proveedorDetalle) {
    const totalPedidos = detalleProveedor.length;
    const pedidosExactos = detalleProveedor.filter(d => Number(d.dif_descarga) === 0).length;
    const pctExactitud = getPorcentaje(pedidosExactos, totalPedidos);
    const totalDifDesc = detalleProveedor.filter(d => Number(d.dif_descarga) !== 0).length;
    const conObservaciones = detalleProveedor.filter(d => d.observacion_descarga).length;

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.botonVolver} onClick={() => { setProveedorDetalle(null); setDetalleProveedor([]); }}>← Volver</button>
          <h3 style={styles.titulo}>🏪 {proveedorDetalle.nombre}</h3>
          <button style={styles.botonExcel} onClick={exportarExcelDetalleProveedor}>📥 Excel</button>
        </div>
        <div style={styles.filtros}>
          <div style={styles.filtroItem}><label style={styles.label}>Desde</label>
            <input style={styles.inputFecha} type="date" value={filtroDesdeDetalle} onChange={(e) => setFiltroDesdeDetalle(e.target.value)} /></div>
          <div style={styles.filtroItem}><label style={styles.label}>Hasta</label>
            <input style={styles.inputFecha} type="date" value={filtroHastaDetalle} onChange={(e) => setFiltroHastaDetalle(e.target.value)} /></div>
          <button style={styles.botonFiltrar} onClick={() => cargarDetalleProveedor(proveedorDetalle, filtroDesdeDetalle, filtroHastaDetalle)}>🔍 Filtrar</button>
          {(filtroDesdeDetalle || filtroHastaDetalle) && (
            <button style={styles.botonLimpiar} onClick={() => { setFiltroDesdeDetalle(''); setFiltroHastaDetalle(''); cargarDetalleProveedor(proveedorDetalle); }}>✕</button>
          )}
        </div>
        <div style={styles.tarjetasResumen}>
          {[
            { icono: '📋', valor: totalPedidos, label: 'Pedidos' },
            { icono: '🎯', valor: `${pctExactitud}%`, label: '% Exactitud', color: getColorPorcentaje(pctExactitud) },
            { icono: '⚠️', valor: totalDifDesc, label: 'Con diferencias', color: totalDifDesc > 0 ? '#e74c3c' : '#27ae60' },
            { icono: '📝', valor: conObservaciones, label: 'Observaciones', color: conObservaciones > 0 ? '#e67e22' : '#27ae60' },
            { icono: '💰', valor: `$${detalleProveedor.reduce((a, d) => a + (d.precio * (d.cantidad_descargada_real || 0)), 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}`, label: 'Importe total' }
          ].map((s, i) => (
            <div key={i} style={styles.tarjetaStat}>
              <span style={styles.statIcono}>{s.icono}</span>
              <span style={{ ...styles.statValor, color: s.color || '#2c3e50' }}>{s.valor}</span>
              <span style={styles.statLabel}>{s.label}</span>
            </div>
          ))}
        </div>
        <h4 style={styles.subtitulo}>📦 Historial por producto</h4>
        {Object.keys(detalleAgrupado).sort().map(nombreProd => {
          const items = detalleAgrupado[nombreProd];
          const exactos = items.filter(i => Number(i.dif_descarga) === 0).length;
          const pct = getPorcentaje(exactos, items.length);
          return (
            <div key={nombreProd} style={styles.tarjetaProducto}>
              <div style={styles.headerProducto}>
                <div style={styles.prodIzq}>
                  <span style={styles.codProducto}>{items[0].producto_codigo}</span>
                  <span style={styles.nombreProd}>{nombreProd}</span>
                </div>
                <div style={styles.prodDer}>
                  <span style={styles.comprasCount}>{items.length} compras</span>
                  <span style={{ ...styles.pctBadge, backgroundColor: getColorPorcentaje(pct) }}>{pct}% exacto</span>
                </div>
              </div>
              <table style={styles.tableEl}>
                <thead><tr style={styles.thead}>
                  <th style={styles.th}>Fecha</th><th style={styles.th}>Comprado</th>
                  <th style={styles.th}>Cargado</th><th style={styles.th}>Descargado</th>
                  <th style={styles.th}>Dif. Carga</th><th style={styles.th}>Dif. Descarga</th>
                  <th style={styles.th}>Precio $</th><th style={styles.th}>Estado Compra</th>
                  <th style={styles.th}>Estado Descarga</th><th style={styles.th}>Kg Est.</th>
                  <th style={styles.th}>Kg Real</th><th style={styles.th}>Obs.</th>
                </tr></thead>
                <tbody>
                  {items.map((d) => (
                    <tr key={d.id} style={{ ...styles.tr, backgroundColor: Number(d.dif_descarga) !== 0 ? '#fff5f5' : d.observacion_descarga ? '#fff9e6' : 'white' }}>
                      <td style={styles.td}>{new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</td>
                      <td style={styles.tdCent}>{d.cantidad_pedida}</td>
                      <td style={styles.tdCent}>{d.cantidad_cargada || '-'}</td>
                      <td style={styles.tdCent}>{d.cantidad_descargada_real || '-'}</td>
                      <td style={styles.tdCent}><span style={{ color: d.dif_carga === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{d.dif_carga === 0 ? '✅' : `${d.dif_carga > 0 ? '+' : ''}${d.dif_carga}`}</span></td>
                      <td style={styles.tdCent}><span style={{ color: d.dif_descarga === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{d.dif_descarga === 0 ? '✅' : `${d.dif_descarga > 0 ? '+' : ''}${d.dif_descarga}`}</span></td>
                      <td style={styles.td}>${Number(d.precio).toLocaleString('es-AR')}</td>
                      <td style={styles.td}>{getEstadoLabel(d.estado_mercaderia)}</td>
                      <td style={styles.td}>{getEstadoLabel(d.estado_mercaderia_descarga)}</td>
                      <td style={styles.tdCent}>{d.kg_estimado > 0 ? `${d.kg_estimado}kg` : '-'}</td>
                      <td style={styles.tdCent}>{d.kg_real > 0 ? `${d.kg_real}kg` : '-'}</td>
                      <td style={styles.td}>{d.observacion_descarga ? <span style={styles.obsResaltada}>⚠️ {d.observacion_descarga}</span> : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>📊 Análisis</h3>
      <div style={styles.tabs}>
        {[
          { id: 'general', label: '🌐 General' },
          { id: 'compras', label: '📋 Por Compra' },
          { id: 'proveedores', label: '🏪 Por Proveedor' },
          { id: 'productos', label: '📦 Por Producto' },
          { id: 'ranking', label: '📊 Ranking Errores' },
          { id: 'peso', label: '⚖️ Diferencias Peso' }
        ].map(tab => (
          <button key={tab.id} style={{ ...styles.tab, ...(seccion === tab.id ? styles.tabActivo : {}) }}
            onClick={() => setSeccion(tab.id)}>{tab.label}</button>
        ))}
      </div>

      {cargando && <div style={styles.cargando}>⏳ Cargando datos...</div>}

      {/* GENERAL */}
      {seccion === 'general' && (
        <div>
          {general && (
            <div style={styles.tarjetasResumen}>
              {[
                { icono: '📋', valor: general.total_compras, label: 'Compras cerradas' },
                { icono: '🏪', valor: general.total_proveedores_usados, label: 'Proveedores usados' },
                { icono: '📦', valor: general.total_productos_distintos, label: 'Productos distintos' },
                { icono: '💰', valor: `$${Number(general.importe_total || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}`, label: 'Importe total' },
                { icono: '🧺', valor: `$${Number(general.importe_vacios_total || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}`, label: 'Total vacíos' },
                { icono: '🎯', valor: `${getPorcentaje(general.pedidos_exactos, general.total_pedidos)}%`, label: '% Exactitud', color: getColorPorcentaje(getPorcentaje(general.pedidos_exactos, general.total_pedidos)) },
                { icono: '⚠️', valor: general.total_dif_descarga || 0, label: 'Diferencias descarga', color: general.total_dif_descarga > 0 ? '#e74c3c' : '#27ae60' },
                { icono: '📝', valor: general.total_observaciones || 0, label: 'Observaciones', color: general.total_observaciones > 0 ? '#e67e22' : '#27ae60' }
              ].map((s, i) => (
                <div key={i} style={styles.tarjetaStat}>
                  <span style={styles.statIcono}>{s.icono}</span>
                  <span style={{ ...styles.statValor, color: s.color || '#2c3e50' }}>{s.valor}</span>
                  <span style={styles.statLabel}>{s.label}</span>
                </div>
              ))}
            </div>
          )}

          <div style={styles.busquedaBox}>
            <h4 style={styles.busquedaTitulo}>🔍 Búsqueda Avanzada</h4>
            <div style={styles.busquedaFiltros}>
              <div style={styles.filtroItem}>
                <label style={styles.label}>Desde</label>
                <input style={styles.inputFecha} type="date" value={filtroDesdeGen} onChange={(e) => setFiltroDesdeGen(e.target.value)} />
              </div>
              <div style={styles.filtroItem}>
                <label style={styles.label}>Hasta</label>
                <input style={styles.inputFecha} type="date" value={filtroHastaGen} onChange={(e) => setFiltroHastaGen(e.target.value)} />
              </div>
              <div style={styles.filtroItem}>
                <label style={styles.label}>Proveedor</label>
                <select style={styles.selectFiltro} value={filtroProvBusq} onChange={(e) => setFiltroProvBusq(e.target.value)}>
                  <option value="">Todos los proveedores</option>
                  {listaProveedores.map(p => (
                    <option key={p.id} value={p.id}>{p.nombre}</option>
                  ))}
                </select>
              </div>
            </div>
            <div style={styles.productosSelector}>
              <label style={styles.label}>Productos (seleccioná uno o más):</label>
              <input style={styles.buscadorProd} type="text" placeholder="Buscar producto..."
                value={filtroProdBusq} onChange={(e) => setFiltroProdBusq(e.target.value)} />
              <div style={styles.listaProductosSel}>
                {listaProductosFiltrada.slice(0, 50).map(p => (
                  <div key={p.id}
                    style={{ ...styles.itemProducto, backgroundColor: productosSeleccionados.includes(p.id) ? '#eaf2ff' : 'white', border: productosSeleccionados.includes(p.id) ? '1px solid #3498db' : '1px solid #ecf0f1' }}
                    onClick={() => toggleProducto(p.id)}>
                    <span style={styles.codProd}>{p.codigo_barras}</span>
                    <span style={styles.nomProd}>{p.nombre}</span>
                    {productosSeleccionados.includes(p.id) && <span style={styles.checkProd}>✓</span>}
                  </div>
                ))}
              </div>
              {productosSeleccionados.length > 0 && (
                <div style={styles.seleccionados}>
                  <span style={styles.selCount}>{productosSeleccionados.length} producto(s) seleccionado(s)</span>
                  <button style={styles.botonLimpiar} onClick={() => setProductosSeleccionados([])}>✕ Limpiar</button>
                </div>
              )}
            </div>
            <div style={styles.busquedaBotones}>
              <button style={styles.botonBuscar} onClick={buscarAvanzado} disabled={buscando}>
                {buscando ? '⏳ Buscando...' : '🔍 Buscar'}
              </button>
              {resultadoBusqueda.length > 0 && (
                <button style={styles.botonExcel} onClick={exportarExcelBusqueda}>📥 Exportar Excel</button>
              )}
            </div>
            {resultadoBusqueda.length > 0 && (
              <div style={{ marginTop: '20px' }}>
                <div style={styles.contadorFiltro}>{resultadoBusqueda.length} registros — hacé clic para ver detalle</div>
                {Object.keys(resultadoAgrupado).sort().map(key => {
                  const items = resultadoAgrupado[key];
                  const exactos = items.filter(i => Number(i.dif_descarga) === 0).length;
                  const pct = getPorcentaje(exactos, items.length);
                  const abierto = productoDetalle === key;
                  const precioMin = Math.min(...items.map(i => i.precio));
                  const precioMax = Math.max(...items.map(i => i.precio));
                  const provs = [...new Set(items.map(i => i.proveedor_nombre))].join(', ');
                  return (
                    <div key={key} style={styles.tarjetaResultado}>
                      <div style={styles.headerResultado} onClick={() => setProductoDetalle(abierto ? null : key)}>
                        <div style={styles.resultadoIzq}>
                          <span style={styles.codProducto}>{items[0].producto_codigo}</span>
                          <span style={styles.nombreProd}>{items[0].producto_nombre}</span>
                        </div>
                        <div style={styles.resultadoInfo}>
                          <span style={styles.infoChip}>🏪 {provs}</span>
                          <span style={styles.infoChip}>💰 ${precioMin.toLocaleString('es-AR')} — ${precioMax.toLocaleString('es-AR')}</span>
                          <span style={styles.infoChip}>{items.length} compras</span>
                          <span style={{ ...styles.pctBadge, backgroundColor: getColorPorcentaje(pct) }}>{pct}% exacto</span>
                          <span style={styles.flecha}>{abierto ? '▲' : '▼'}</span>
                        </div>
                      </div>
                      {abierto && (
                        <table style={styles.tableEl}>
                          <thead><tr style={styles.thead}>
                            <th style={styles.th}>Fecha</th><th style={styles.th}>Proveedor</th>
                            <th style={styles.th}>Comprado</th><th style={styles.th}>Descargado</th>
                            <th style={styles.th}>Dif. Carga</th><th style={styles.th}>Dif. Descarga</th>
                            <th style={styles.th}>Precio $</th><th style={styles.th}>Estado</th>
                            <th style={styles.th}>Obs.</th>
                          </tr></thead>
                          <tbody>
                            {items.map((d, i) => (
                              <tr key={i} style={{ ...styles.tr, backgroundColor: Number(d.dif_descarga) !== 0 ? '#fff5f5' : d.observacion_descarga ? '#fff9e6' : 'white' }}>
                                <td style={styles.td}>{new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</td>
                                <td style={styles.td}>{d.proveedor_nombre}</td>
                                <td style={styles.tdCent}>{d.cantidad_pedida}</td>
                                <td style={styles.tdCent}>{d.cantidad_descargada_real || '-'}</td>
                                <td style={styles.tdCent}><span style={{ color: Number(d.dif_carga) === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{Number(d.dif_carga) === 0 ? '✅' : `${d.dif_carga}`}</span></td>
                                <td style={styles.tdCent}><span style={{ color: Number(d.dif_descarga) === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{Number(d.dif_descarga) === 0 ? '✅' : `${d.dif_descarga}`}</span></td>
                                <td style={styles.td}>${Number(d.precio).toLocaleString('es-AR')}</td>
                                <td style={styles.td}>{getEstadoLabel(d.estado_mercaderia_descarga)}</td>
                                <td style={styles.td}>{d.observacion_descarga ? <span style={styles.obsResaltada}>⚠️ {d.observacion_descarga}</span> : '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      {/* POR COMPRA */}
      {seccion === 'compras' && (
        <div>
          <div style={styles.barraAcciones}>
            <div style={styles.filtros}>
              <div style={styles.filtroItem}><label style={styles.label}>Desde</label>
                <input style={styles.inputFecha} type="date" value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} /></div>
              <div style={styles.filtroItem}><label style={styles.label}>Hasta</label>
                <input style={styles.inputFecha} type="date" value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} /></div>
              {(filtroDesde || filtroHasta) && <button style={styles.botonLimpiar} onClick={() => { setFiltroDesde(''); setFiltroHasta(''); }}>✕ Limpiar</button>}
            </div>
            <button style={styles.botonExcel} onClick={() => {
              const wb = XLSX.utils.book_new();
              const data = comprasFiltradas.map(c => ({ 'Fecha': new Date(c.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" }), 'Comentario': c.comentario || '', 'Proveedores': c.total_proveedores, 'Productos': c.total_productos, 'Total Merc. $': Number(c.total_importe || 0).toFixed(2), 'Total Vacíos $': Number(c.total_vacios || 0).toFixed(2), 'Flete': c.flete_tipo }));
              const ws = XLSX.utils.json_to_sheet(data);
              XLSX.utils.book_append_sheet(wb, ws, 'Compras');
              const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
              saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Compras_${new Date().toLocaleDateString('es-AR').replace(/\//g, '-')}.xlsx`);
            }}>📥 Exportar Excel</button>
          </div>
          <div style={styles.contadorFiltro}>Mostrando {comprasFiltradas.length} de {compras.length} compras</div>
          <div style={styles.tablaContainer}>
            <table style={styles.tableEl}>
              <thead><tr style={styles.thead}>
                <th style={styles.th}>Fecha</th><th style={styles.th}>Comentario</th>
                <th style={styles.th}>Proveedores</th><th style={styles.th}>Productos</th>
                <th style={styles.th}>Total Merc. $</th><th style={styles.th}>Total Vacíos $</th>
                <th style={styles.th}>Flete</th><th style={styles.th}>Inicio</th>
                <th style={styles.th}>Fin</th><th style={styles.th}>Dif. Carga</th>
                <th style={styles.th}>Dif. Descarga</th>
              </tr></thead>
              <tbody>
                {comprasFiltradas.map((c) => {
                  const difCarga = Math.abs((c.total_cargado || 0) - (c.total_comprado || 0));
                  const difDesc = Math.abs((c.total_descargado || 0) - (c.total_comprado || 0));
                  return (
                    <tr key={c.id} style={styles.tr}>
                      <td style={styles.td}>{new Date(c.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</td>
                      <td style={styles.td}>{c.comentario || '-'}</td>
                      <td style={styles.tdCent}>{c.total_proveedores}</td>
                      <td style={styles.tdCent}>{c.total_productos}</td>
                      <td style={styles.td}>${Number(c.total_importe || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}</td>
                      <td style={styles.td}>${Number(c.total_vacios || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}</td>
                      <td style={styles.td}>{c.flete_tipo}</td>
                      <td style={styles.td}>{c.hora_inicio_descarga || '-'}</td>
                      <td style={styles.td}>{c.hora_fin_descarga || '-'}</td>
                      <td style={styles.td}><span style={{ color: difCarga === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{difCarga === 0 ? '✅' : `⚠️ ${difCarga}`}</span></td>
                      <td style={styles.td}><span style={{ color: difDesc === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{difDesc === 0 ? '✅' : `⚠️ ${difDesc}`}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* POR PROVEEDOR */}
      {seccion === 'proveedores' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar proveedor..."
              value={busquedaProv} onChange={(e) => setBusquedaProv(e.target.value)} />
            <button style={styles.botonExcel} onClick={exportarExcelProveedores}>📥 Exportar Excel</button>
          </div>
          <div style={styles.contadorFiltro}>Mostrando {proveedoresFiltrados.length} proveedores</div>
          <div style={styles.tablaContainer}>
            <table style={styles.tableEl}>
              <thead><tr style={styles.thead}>
                <th style={styles.th}>Código</th><th style={styles.th}>Proveedor</th>
                <th style={styles.th}>Compras</th><th style={styles.th}>Importe total $</th>
                <th style={styles.th}>% Exactitud</th><th style={styles.th}>Dif. descarga</th>
                <th style={styles.th}>Observaciones</th><th style={styles.th}>Ver detalle</th>
              </tr></thead>
              <tbody>
                {proveedoresFiltrados.map((p) => {
                  const pct = getPorcentaje(p.pedidos_exactos, p.total_pedidos);
                  return (
                    <tr key={p.id} style={styles.tr}>
                      <td style={styles.tdCodigo}>{p.codigo_sistema}</td>
                      <td style={styles.td}>{p.nombre}</td>
                      <td style={styles.tdCent}>{p.total_compras}</td>
                      <td style={styles.td}>${Number(p.total_importe || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}</td>
                      <td style={styles.tdCent}><span style={{ color: getColorPorcentaje(pct), fontWeight: 'bold', fontSize: '15px' }}>{pct}%</span></td>
                      <td style={styles.tdCent}><span style={{ color: (p.total_dif_descarga || 0) === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{(p.total_dif_descarga || 0) === 0 ? '✅' : `⚠️ ${p.total_dif_descarga}`}</span></td>
                      <td style={styles.tdCent}><span style={{ color: (p.total_observaciones || 0) > 0 ? '#e67e22' : '#27ae60' }}>{(p.total_observaciones || 0) > 0 ? `📝 ${p.total_observaciones}` : '✅'}</span></td>
                      <td style={styles.td}><button style={styles.botonDetalle} onClick={() => cargarDetalleProveedor(p)}>🔍 Ver historial</button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* POR PRODUCTO */}
      {seccion === 'productos' && (
        <div>
          <div style={styles.barraAcciones}>
            <input style={styles.buscador} type="text" placeholder="Buscar producto..."
              value={busquedaProd} onChange={(e) => setBusquedaProd(e.target.value)} />
            <button style={styles.botonExcel} onClick={exportarExcelProductos}>📥 Exportar Excel</button>
          </div>
          <div style={styles.contadorFiltro}>Mostrando {productosFiltrados.length} productos</div>
          <div style={styles.tablaContainer}>
            <table style={styles.tableEl}>
              <thead><tr style={styles.thead}>
                <th style={styles.th}>Código</th><th style={styles.th}>Producto</th>
                <th style={styles.th}>Proveedores</th><th style={styles.th}>Veces comprado</th>
                <th style={styles.th}>Precio mín $</th><th style={styles.th}>Precio prom $</th>
                <th style={styles.th}>Precio máx $</th><th style={styles.th}>Diferencias</th>
              </tr></thead>
              <tbody>
                {productosFiltrados.map((p) => (
                  <tr key={p.id} style={styles.tr}>
                    <td style={styles.tdCodigo}>{p.codigo_barras}</td>
                    <td style={styles.td}>{p.nombre}</td>
                    <td style={styles.td}><span style={{ fontSize: '12px', color: '#7f8c8d' }}>{p.proveedores || '-'}</span></td>
                    <td style={styles.tdCent}>{p.veces_comprado}</td>
                    <td style={styles.td}>${Number(p.precio_minimo || 0).toLocaleString('es-AR')}</td>
                    <td style={styles.td}>${Number(p.precio_promedio || 0).toLocaleString('es-AR', { minimumFractionDigits: 0 })}</td>
                    <td style={styles.td}>${Number(p.precio_maximo || 0).toLocaleString('es-AR')}</td>
                    <td style={styles.tdCent}><span style={{ color: (p.total_diferencias || 0) === 0 ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }}>{(p.total_diferencias || 0) === 0 ? '✅' : `⚠️ ${p.total_diferencias}`}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* RANKING ERRORES */}
      {seccion === 'ranking' && (
        <div>
          <div style={styles.card}>
            <div style={styles.rankingFiltros}>
              <div style={styles.tipoSelector}>
                <button style={{ ...styles.tipoBtnRanking, ...(tipoRanking === 'proveedor' ? styles.tipoBtnActivo : {}) }}
                  onClick={() => setTipoRanking('proveedor')}>🏪 Por Proveedor</button>
                <button style={{ ...styles.tipoBtnRanking, ...(tipoRanking === 'producto' ? styles.tipoBtnActivo : {}) }}
                  onClick={() => setTipoRanking('producto')}>📦 Por Producto</button>
              </div>
              <div style={styles.filtros}>
                <div style={styles.filtroItem}><label style={styles.label}>Desde</label>
                  <input style={styles.inputFecha} type="date" value={filtroDesdeRanking} onChange={(e) => setFiltroDesdeRanking(e.target.value)} /></div>
                <div style={styles.filtroItem}><label style={styles.label}>Hasta</label>
                  <input style={styles.inputFecha} type="date" value={filtroHastaRanking} onChange={(e) => setFiltroHastaRanking(e.target.value)} /></div>
                <button style={styles.botonFiltrar} onClick={cargarRankingErrores}>🔍 Filtrar</button>
                {(filtroDesdeRanking || filtroHastaRanking) && (
                  <button style={styles.botonLimpiar} onClick={() => { setFiltroDesdeRanking(''); setFiltroHastaRanking(''); }}>✕</button>
                )}
              </div>
              {rankingErrores.length > 0 && (
                <button style={styles.botonExcel} onClick={exportarExcelRanking}>📥 Exportar Excel</button>
              )}
            </div>
          </div>

          {cargandoRanking && <div style={styles.cargando}>⏳ Cargando ranking...</div>}

          {!cargandoRanking && rankingErrores.length === 0 && (
            <div style={styles.sinDatos}>✅ No hay errores registrados para el período seleccionado</div>
          )}

          {!cargandoRanking && rankingErrores.length > 0 && tipoRanking === 'proveedor' && (
            <div style={styles.tablaContainer}>
              <table style={styles.tableEl}>
                <thead><tr style={styles.thead}>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Proveedor</th>
                  <th style={styles.th}>Compras</th>
                  <th style={styles.th}>Errores cant.</th>
                  <th style={styles.th}>Unidades dif.</th>
                  <th style={styles.th}>🔴 Dem. maduro</th>
                  <th style={styles.th}>🟠 Maduro</th>
                  <th style={styles.th}>Cambios estado</th>
                  <th style={styles.th}>Observaciones</th>
                  <th style={styles.th}>Veces avisado</th>
                  <th style={styles.th}>% Exactitud</th>
                </tr></thead>
                <tbody>
                  {rankingErrores.map((r, i) => (
                    <tr key={r.id} style={{ ...styles.tr, backgroundColor: i === 0 ? '#fff5f5' : i === 1 ? '#fff9f0' : 'white' }}>
                      <td style={styles.tdCent}>
                        <span style={{ fontWeight: 'bold', fontSize: '16px', color: i === 0 ? '#e74c3c' : i === 1 ? '#e67e22' : i === 2 ? '#f39c12' : '#7f8c8d' }}>
                          {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
                        </span>
                      </td>
                      <td style={styles.td}><strong>{r.nombre}</strong></td>
                      <td style={styles.tdCent}>{r.total_compras}</td>
                      <td style={styles.tdCent}><span style={{ color: r.errores_cantidad > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.errores_cantidad || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.total_unidades_dif > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.total_unidades_dif || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_demasiado_maduro > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.veces_demasiado_maduro || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_maduro > 0 ? '#e67e22' : '#27ae60' }}>{r.veces_maduro || 0}</span></td>
                      <td style={styles.tdCent}>{r.cambios_estado || 0}</td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_con_obs > 0 ? '#e67e22' : '#27ae60' }}>{r.veces_con_obs || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_avisado > 0 ? '#27ae60' : '#95a5a6' }}>{r.veces_avisado || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: getColorPorcentaje(r.pct_exactitud || 0), fontWeight: 'bold', fontSize: '15px' }}>{r.pct_exactitud || 0}%</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {!cargandoRanking && rankingErrores.length > 0 && tipoRanking === 'producto' && (
            <div style={styles.tablaContainer}>
              <table style={styles.tableEl}>
                <thead><tr style={styles.thead}>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Código</th>
                  <th style={styles.th}>Producto</th>
                  <th style={styles.th}>Proveedores</th>
                  <th style={styles.th}>Compras</th>
                  <th style={styles.th}>Errores cant.</th>
                  <th style={styles.th}>Unidades dif.</th>
                  <th style={styles.th}>🔴 Dem. maduro</th>
                  <th style={styles.th}>🟠 Maduro</th>
                  <th style={styles.th}>Cambios estado</th>
                  <th style={styles.th}>Observaciones</th>
                </tr></thead>
                <tbody>
                  {rankingErrores.map((r, i) => (
                    <tr key={r.id} style={{ ...styles.tr, backgroundColor: i === 0 ? '#fff5f5' : i === 1 ? '#fff9f0' : 'white' }}>
                      <td style={styles.tdCent}>
                        <span style={{ fontWeight: 'bold', fontSize: '16px', color: i === 0 ? '#e74c3c' : i === 1 ? '#e67e22' : i === 2 ? '#f39c12' : '#7f8c8d' }}>
                          {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1}
                        </span>
                      </td>
                      <td style={styles.tdCodigo}>{r.codigo_barras}</td>
                      <td style={styles.td}><strong>{r.nombre}</strong></td>
                      <td style={styles.td}><span style={{ fontSize: '12px', color: '#7f8c8d' }}>{r.proveedores || '-'}</span></td>
                      <td style={styles.tdCent}>{r.total_compras}</td>
                      <td style={styles.tdCent}><span style={{ color: r.errores_cantidad > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.errores_cantidad || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.total_unidades_dif > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.total_unidades_dif || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_demasiado_maduro > 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{r.veces_demasiado_maduro || 0}</span></td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_maduro > 0 ? '#e67e22' : '#27ae60' }}>{r.veces_maduro || 0}</span></td>
                      <td style={styles.tdCent}>{r.cambios_estado || 0}</td>
                      <td style={styles.tdCent}><span style={{ color: r.veces_con_obs > 0 ? '#e67e22' : '#27ae60' }}>{r.veces_con_obs || 0}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      {seccion === 'peso' && (
        <div>
          <div style={styles.card}>
            <div style={styles.tipoSelector}>
              <button style={{ ...styles.tipoBtnRanking, ...(vistaPeso === 'proveedores' ? styles.tipoBtnActivo : {}) }}
                onClick={() => { setVistaPeso('proveedores'); setPesoDetalleTipo(null); }}>Por Proveedor</button>
              <button style={{ ...styles.tipoBtnRanking, ...(vistaPeso === 'productos' ? styles.tipoBtnActivo : {}) }}
                onClick={() => { setVistaPeso('productos'); setPesoDetalleTipo(null); }}>Por Producto</button>
              <button style={{ ...styles.tipoBtnRanking, ...(vistaPeso === 'plan' ? styles.tipoBtnActivo : {}) }}
                onClick={() => { setVistaPeso('plan'); setPesoDetalleTipo(null); }}>Por Compra</button>
              <button style={{ ...styles.tipoBtnRanking, ...(vistaPeso === "ranking" ? styles.tipoBtnActivo : {}) }} onClick={() => { setVistaPeso("ranking"); setPesoDetalleTipo(null); }}>Ranking General</button>
            </div>
            {vistaPeso === 'plan' && (
              <div style={styles.filtros}>
                <div style={styles.filtroItem}>
                  <label style={styles.label}>Elegir compra</label>
                  <select style={styles.inputFecha} value={pesoPlanId} onChange={(e) => { setPesoPlanId(e.target.value); cargarPesoPlan(e.target.value); }}>
                    <option value="">-- Seleccionar --</option>
                    {planesParaPeso.map(p => (
                      <option key={p.id} value={p.id}>{new Date(p.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })} (Plan {p.id} - {p.estado})</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
          {cargandoPeso && <div style={styles.cargando}>Cargando...</div>}
          {!cargandoPeso && vistaPeso === 'proveedores' && !pesoDetalleTipo && (
            pesoProveedores.length === 0 ? (
              <div style={styles.sinDatos}>No hay datos de kg estimado/real cargados todavia</div>
            ) : (
              <div style={styles.tablaContainer}>
                <table style={styles.tableEl}>
                  <thead><tr style={styles.thead}>
                    <th style={styles.th}>#</th><th style={styles.th}>Proveedor</th>
                    <th style={styles.th}>Registros</th><th style={styles.th}>Kg Estimado</th>
                    <th style={styles.th}>Kg Real (neto)</th><th style={styles.th}>Dif. Kg</th>
                    <th style={styles.th}>Dif. %</th><th style={styles.th}></th>
                  </tr></thead>
                  <tbody>
                    {pesoProveedores.map((p, i) => (
                      <tr key={p.id} style={styles.tr}>
                        <td style={styles.tdCent}>{i + 1}</td>
                        <td style={styles.td}><strong>{p.nombre}</strong></td>
                        <td style={styles.tdCent}>{p.total_registros}</td>
                        <td style={styles.tdCent}>{Number(p.total_kg_estimado).toFixed(2)} kg</td>
                        <td style={styles.tdCent}>{Number(p.total_kg_real).toFixed(2)} kg</td>
                        <td style={styles.tdCent}><span style={{ color: Number(p.total_dif_kg) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{Number(p.total_dif_kg).toFixed(2)} kg</span></td>
                        <td style={styles.tdCent}><span style={{ color: Number(p.dif_pct_promedio) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{p.dif_pct_promedio}%</span></td>
                        <td style={styles.tdCent}><button style={styles.botonFiltrar} onClick={() => cargarPesoDetalleProveedor(p)}>Ver</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
          {!cargandoPeso && vistaPeso === 'productos' && !pesoDetalleTipo && (
            pesoProductos.length === 0 ? (
              <div style={styles.sinDatos}>No hay datos de kg estimado/real cargados todavia</div>
            ) : (
              <div style={styles.tablaContainer}>
                <table style={styles.tableEl}>
                  <thead><tr style={styles.thead}>
                    <th style={styles.th}>#</th><th style={styles.th}>Producto</th>
                    <th style={styles.th}>Registros</th><th style={styles.th}>Kg Estimado</th>
                    <th style={styles.th}>Kg Real (neto)</th><th style={styles.th}>Dif. Kg</th>
                    <th style={styles.th}>Dif. %</th><th style={styles.th}></th>
                  </tr></thead>
                  <tbody>
                    {pesoProductos.map((p, i) => (
                      <tr key={p.id} style={styles.tr}>
                        <td style={styles.tdCent}>{i + 1}</td>
                        <td style={styles.td}><strong>{p.nombre}</strong></td>
                        <td style={styles.tdCent}>{p.total_registros}</td>
                        <td style={styles.tdCent}>{Number(p.total_kg_estimado).toFixed(2)} kg</td>
                        <td style={styles.tdCent}>{Number(p.total_kg_real).toFixed(2)} kg</td>
                        <td style={styles.tdCent}><span style={{ color: Number(p.total_dif_kg) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{Number(p.total_dif_kg).toFixed(2)} kg</span></td>
                        <td style={styles.tdCent}><span style={{ color: Number(p.dif_pct_promedio) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{p.dif_pct_promedio}%</span></td>
                        <td style={styles.tdCent}><button style={styles.botonFiltrar} onClick={() => cargarPesoDetalleProducto(p)}>Ver</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
          {!cargandoPeso && (pesoDetalleTipo === 'proveedor' || pesoDetalleTipo === 'producto') && (
            <div>
              <button style={styles.botonCancelarPeq} onClick={() => { setPesoDetalleTipo(null); setPesoDetalle([]); }}>Volver</button>
              <h4 style={styles.subtitulo}>{pesoDetalleTitulo}</h4>
              {pesoDetalle.length === 0 ? (
                <div style={styles.sinDatos}>Sin registros</div>
              ) : (
                <div style={styles.tablaContainer}>
                  <table style={styles.tableEl}>
                    <thead><tr style={styles.thead}>
                      <th style={styles.th}>Fecha</th>
                      <th style={styles.th}>{pesoDetalleTipo === 'proveedor' ? 'Producto' : 'Proveedor'}</th>
                      <th style={styles.th}>Kg Estimado</th><th style={styles.th}>Kg Real (neto)</th>
                      <th style={styles.th}>Dif. Kg</th><th style={styles.th}>Dif. %</th>
                    </tr></thead>
                    <tbody>
                      {pesoDetalle.map(d => (
                        <tr key={d.id} style={{ ...styles.tr, backgroundColor: Number(d.dif_kg) < 0 ? '#fff5f5' : Number(d.dif_kg) > 0 ? '#f0fff4' : 'white' }}>
                          <td style={styles.td}>{new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })} (Plan {d.plan_id})</td>
                          <td style={styles.td}>{pesoDetalleTipo === 'proveedor' ? d.producto_nombre : d.proveedor_nombre}</td>
                          <td style={styles.tdCent}>{Number(d.kg_estimado).toFixed(2)} kg</td>
                          <td style={styles.tdCent}>{Number(d.kg_real).toFixed(2)} kg</td>
                          <td style={styles.tdCent}><span style={{ color: Number(d.dif_kg) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{Number(d.dif_kg).toFixed(2)} kg</span></td>
                          <td style={styles.tdCent}><span style={{ color: Number(d.dif_pct) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{d.dif_pct}%</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
          {!cargandoPeso && vistaPeso === 'plan' && (
            pesoPlanId === '' ? (
              <div style={styles.sinDatos}>Elegi una compra para ver el detalle</div>
            ) : pesoDetalle.length === 0 ? (
              <div style={styles.sinDatos}>Sin registros de kg para esta compra</div>
            ) : (
              <div style={styles.tablaContainer}>
                <table style={styles.tableEl}>
                  <thead><tr style={styles.thead}>
                    <th style={styles.th}>Producto</th><th style={styles.th}>Proveedor</th>
                    <th style={styles.th}>Kg Estimado</th><th style={styles.th}>Kg Real (neto)</th>
                    <th style={styles.th}>Dif. Kg</th><th style={styles.th}>Dif. %</th>
                  </tr></thead>
                  <tbody>
                    {pesoDetalle.map(d => (
                      <tr key={d.id} style={{ ...styles.tr, backgroundColor: Number(d.dif_kg) < 0 ? '#fff5f5' : Number(d.dif_kg) > 0 ? '#f0fff4' : 'white' }}>
                        <td style={styles.td}>{d.producto_nombre}</td>
                        <td style={styles.td}>{d.proveedor_nombre}</td>
                        <td style={styles.tdCent}>{Number(d.kg_estimado).toFixed(2)} kg</td>
                        <td style={styles.tdCent}>{Number(d.kg_real).toFixed(2)} kg</td>
                        <td style={styles.tdCent}><span style={{ color: Number(d.dif_kg) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{Number(d.dif_kg).toFixed(2)} kg</span></td>
                        <td style={styles.tdCent}><span style={{ color: Number(d.dif_pct) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{d.dif_pct}%</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
          {!cargandoPeso && vistaPeso === 'ranking' && (
            pesoRankingGeneral.length === 0 ? (
              <div style={styles.sinDatos}>No hay productos con "Se pesa" marcado que tengan datos de kg</div>
            ) : (
              <div style={styles.tablaContainer}>
                <table style={styles.tableEl}>
                  <thead><tr style={styles.thead}>
                    <th style={styles.th}>#</th>
                    <th style={styles.th}>Fecha</th>
                    <th style={styles.th}>Producto</th>
                    <th style={styles.th}>Proveedor</th>
                    <th style={styles.th}>Kg Estimado</th>
                    <th style={styles.th}>Kg Real (neto)</th>
                    <th style={styles.th}>Dif. Kg</th>
                    <th style={styles.th}>Dif. %</th>
                  </tr></thead>
                  <tbody>
                    {pesoRankingGeneral.map((d, i) => (
                      <tr key={d.id} style={{ ...styles.tr, backgroundColor: Number(d.dif_kg) < 0 ? '#fff5f5' : Number(d.dif_kg) > 0 ? '#f0fff4' : 'white' }}>
                        <td style={styles.tdCent}>{i + 1}</td>
                        <td style={styles.td}>{new Date(d.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</td>
                        <td style={styles.td}>{d.producto_nombre}</td>
                        <td style={styles.td}>{d.proveedor_nombre}</td>
                        <td style={styles.tdCent}>{Number(d.kg_estimado).toFixed(2)} kg</td>
                        <td style={styles.tdCent}>{Number(d.kg_real).toFixed(2)} kg</td>
                        <td style={styles.tdCent}><span style={{ color: Number(d.dif_kg) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{Number(d.dif_kg).toFixed(2)} kg</span></td>
                        <td style={styles.tdCent}><span style={{ color: Number(d.dif_pct) < 0 ? '#e74c3c' : '#27ae60', fontWeight: 'bold' }}>{d.dif_pct}%</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' },
  titulo: { color: '#2c3e50', fontSize: '22px', margin: 0 },
  subtitulo: { color: '#2c3e50', fontSize: '18px', margin: '20px 0 10px 0' },
  tabs: { display: 'flex', gap: '5px', marginBottom: '20px', flexWrap: 'wrap' },
  tab: { padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '14px' },
  tabActivo: { backgroundColor: '#27ae60', color: 'white', border: '1px solid #27ae60' },
  cargando: { textAlign: 'center', padding: '40px', color: '#7f8c8d', fontSize: '16px' },
  tarjetasResumen: { display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px' },
  tarjetaStat: { backgroundColor: 'white', padding: '20px 25px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', minWidth: '150px' },
  statIcono: { fontSize: '28px' },
  statValor: { fontSize: '20px', fontWeight: 'bold', color: '#2c3e50' },
  statLabel: { fontSize: '12px', color: '#7f8c8d', textAlign: 'center' },
  busquedaBox: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginTop: '20px' },
  busquedaTitulo: { color: '#2c3e50', fontSize: '18px', marginBottom: '20px' },
  busquedaFiltros: { display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px' },
  productosSelector: { marginBottom: '20px' },
  buscadorProd: { padding: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', width: '100%', maxWidth: '400px', marginBottom: '10px', marginTop: '5px' },
  listaProductosSel: { maxHeight: '200px', overflowY: 'auto', border: '1px solid #ecf0f1', borderRadius: '6px' },
  itemProducto: { padding: '8px 15px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', borderBottom: '1px solid #f8f9fa' },
  codProd: { backgroundColor: '#3498db', color: 'white', padding: '1px 6px', borderRadius: '3px', fontSize: '11px', whiteSpace: 'nowrap' },
  nomProd: { fontSize: '13px', color: '#2c3e50', flex: 1 },
  checkProd: { color: '#3498db', fontWeight: 'bold' },
  seleccionados: { display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' },
  selCount: { fontSize: '13px', color: '#3498db', fontWeight: 'bold' },
  busquedaBotones: { display: 'flex', gap: '10px', marginTop: '15px' },
  botonBuscar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  tarjetaResultado: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '10px', overflow: 'hidden', border: '1px solid #ecf0f1' },
  headerResultado: { padding: '12px 20px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' },
  resultadoIzq: { display: 'flex', alignItems: 'center', gap: '10px' },
  resultadoInfo: { display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' },
  infoChip: { backgroundColor: '#f8f9fa', padding: '3px 10px', borderRadius: '20px', fontSize: '12px', color: '#2c3e50' },
  flecha: { color: '#95a5a6', fontSize: '12px' },
  card: { backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  rankingFiltros: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  tipoSelector: { display: 'flex', gap: '5px' },
  tipoBtnRanking: { padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '14px' },
  tipoBtnActivo: { backgroundColor: '#e74c3c', color: 'white', border: '1px solid #e74c3c' },
  sinDatos: { textAlign: 'center', color: '#95a5a6', padding: '40px', backgroundColor: 'white', borderRadius: '10px' },
  barraAcciones: { display: 'flex', gap: '15px', marginBottom: '10px', alignItems: 'flex-end', flexWrap: 'wrap' },
  filtros: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: '15px' },
  filtroItem: { display: 'flex', flexDirection: 'column', gap: '4px' },
  label: { fontSize: '12px', color: '#7f8c8d' },
  inputFecha: { padding: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  selectFiltro: { padding: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', minWidth: '200px' },
  botonFiltrar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer' },
  botonLimpiar: { padding: '8px 15px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: 'white', cursor: 'pointer', fontSize: '13px', color: '#e74c3c' },
  botonExcel: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', whiteSpace: 'nowrap' },
  botonVolver: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  botonDetalle: { backgroundColor: '#eaf2ff', color: '#2980b9', border: '1px solid #2980b9', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  contadorFiltro: { fontSize: '13px', color: '#7f8c8d', marginBottom: '10px' },
  buscador: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', flex: 1, maxWidth: '400px' },
  tablaContainer: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', overflowX: 'auto' },
  tableEl: { width: '100%', borderCollapse: 'collapse' },
  thead: { backgroundColor: '#2c3e50' },
  th: { color: 'white', padding: '12px 15px', textAlign: 'left', fontSize: '12px', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  td: { padding: '10px 15px', fontSize: '13px', color: '#2c3e50' },
  tdCodigo: { padding: '10px 15px', fontSize: '12px', color: '#3498db', fontWeight: 'bold' },
  tdCent: { padding: '10px 15px', fontSize: '13px', color: '#2c3e50', textAlign: 'center' },
  tarjetaProducto: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '15px', overflow: 'hidden' },
  headerProducto: { backgroundColor: '#34495e', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  prodIzq: { display: 'flex', alignItems: 'center', gap: '10px' },
  codProducto: { backgroundColor: '#3498db', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' },
  nombreProd: { color: 'white', fontWeight: 'bold', fontSize: '14px' },
  prodDer: { display: 'flex', gap: '10px', alignItems: 'center' },
  comprasCount: { color: 'rgba(255,255,255,0.7)', fontSize: '13px' },
  pctBadge: { color: 'white', padding: '3px 10px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold' },
  obsResaltada: { color: '#e74c3c', fontWeight: 'bold', fontSize: '12px' }
};

export default Analisis;
